import React from 'react';
import _get from 'lodash/get';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function OnboardingRoute({ children, path }) {
  const test = useSelector(state => state.test);
  const { usertype } = useSelector(state => state.auth.initUserDetails);
  const {
    is_onboarded: isOnboarded,
    is_expired: isExpired,
    slug: testSlug,
  } = test;
  const isCustomFormEnabled = _get(
    test,
    'settings.hacker_extra_data.custom_data.enabled'
  );

  let hasAccess = true;
  let redirectPath = `/${testSlug}/onboarding/form`;

  if (isExpired === true && testSlug) {
    hasAccess = false;
    redirectPath = `/test/${testSlug}/feedback`;
  } else if (
    (isExpired === false &&
      isCustomFormEnabled === true &&
      isOnboarded === true &&
      testSlug) ||
    (usertype !== 'hacker' && testSlug)
  ) {
    hasAccess = false;
    redirectPath = `/test/${testSlug}/`;
  } // @Todo add onboarding check after this

  return (
    <Route
      path={path}
      render={props =>
        hasAccess ? (
          <>{children}</>
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}
